import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import Termos from "@/pages/Termos";

export const Route = createFileRoute("/termos")({
  head: () => seoHead({
    title: "Termos de Uso | Shopping do Bem",
    description: "Termos de uso do Shopping do Bem.",
    path: "/termos",
  }),
  component: Termos,
});
